export default "__VITE_ASSET__C4oPRyqg__"